import { render } from "./Icon.vue?vue&type=template&id=2f0f7aba&scoped=true"
import script from "./Icon.js?vue&type=script&lang=js"
export * from "./Icon.js?vue&type=script&lang=js"

import "./Icon.scss?vue&type=style&index=0&id=2f0f7aba&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0f7aba"]])

export default __exports__